import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { LogsModal } from "./components/LogsModal";
import { ProcessTable } from "./components/ProcessTable";
import { UnauthorizedAccess } from "./components/UnauthorizedAccess";
import AccessForm from "./components/UserAccess";
import ReportsTable from "./components/UserReports";
import { usePm2 } from "./hooks/usePm2";

const Admtools: React.FC = () => {
  const { processes, restart, stop, logs, isUnauthorized } = usePm2();

  const [isLogsModalOpen, setIsLogsModalOpen] = useState(false);
  const [selectedLogs, setSelectedLogs] = useState<string[]>([]);

  const handleViewLogs = async (name: string) => {
    try {
      const result = await logs.mutateAsync(name);
      setSelectedLogs(result.data.logs);
      setIsLogsModalOpen(true);
    } catch (error) {
      // Error will be handled by mutation's onError
      console.error("Failed to fetch logs:", error);
    }
  };

  if (processes.isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <ThreeDots color="black" />
      </div>
    );
  }

  if (isUnauthorized) {
    return <UnauthorizedAccess />;
  }

  return (
    <div className="mx-auto w-full max-w-7xl p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-zinc-800">PM2 Processes</h1>
        <button
          onClick={() => processes.refetch()}
          className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-primary-700"
        >
          Refresh
        </button>
      </div>

      {processes.isLoading ? (
        <div className="flex h-64 items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-t-2 border-blue-500" />
        </div>
      ) : processes.error ? (
        <div className="rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700">
          Error loading processes
        </div>
      ) : processes.data ? (
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <ProcessTable
            processes={processes.data}
            onRestart={(name) => restart.mutate(name)}
            onStop={(name) => stop.mutate(name)}
            onViewLogs={handleViewLogs}
            isRestarting={restart.isLoading}
            isStopping={stop.isLoading}
          />
        </div>
      ) : null}

      <LogsModal
        isOpen={isLogsModalOpen}
        onClose={() => setIsLogsModalOpen(false)}
        logs={selectedLogs}
      />

      <AccessForm />
      <ReportsTable />
    </div>
  );
};

export default Admtools;
